import { RegisterOptions } from 'react-hook-form';
import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';
import customValidators, { Validation } from '@/helpers/validation/index';
import getTypedKeys from '../getTypedKeys';

type ThisFieldTemplate = Pick<QuestionnaireApiModels.FieldTemplate,
  | 'validation'
  | 'isRequired'
  | 'key'
>;

export const getValidationRules = (field: ThisFieldTemplate): RegisterOptions => {
  const validation: Validation = field.validation || {};
  const rules: RegisterOptions = {};

  if (validation.min) rules.min = validation.min;
  if (validation.max) rules.max = validation.max;
  if (validation.minLength) rules.minLength = validation.minLength;
  if (validation.maxLength) rules.maxLength = validation.maxLength;
  if (validation.type) rules.pattern = validation.pattern;
  if (validation.pattern) rules.pattern = validation.pattern;
  if (field.isRequired) rules.required = "Required";

  // Handle custom validators
  getTypedKeys(customValidators).forEach(validator => {
    if (validation[validator]) {
      rules.validate = {
        ...rules.validate,
        [validator]: () =>
          customValidators[validator](
            validation[validator],
          ) ?? undefined,
      };
    }
  });
  return rules;
};

const generateValidationSchema = (
  fields: ThisFieldTemplate[],
): { [key: string]: RegisterOptions } => {
  const schema: { [key: string]: RegisterOptions } = {};

  fields.forEach(field => {
    const rules = getValidationRules(field);

    schema[field.key] = rules;
  });

  return schema;
};

export default generateValidationSchema;
